/**
 * @desc 修改竞价预告
 */
import {
  AnnouncementEntity,
  ApplyAnnouncementForm
} from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type UpdateApplyAnnouncementParameter = ApplyAnnouncementForm

const method = 'PUT'
const url = '/trade/operation/announcement/apply'

export const updateApplyAnnouncementApi = (
  data?: UpdateApplyAnnouncementParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<AnnouncementEntity>({
    method,
    url,
    data,
    ...config
  })
}

updateApplyAnnouncementApi.method = method
updateApplyAnnouncementApi.url = url
